import { render, staticRenderFns } from "./LockDetail.vue?vue&type=template&id=39ecdc5b&"
import script from "./LockDetail.vue?vue&type=script&lang=js&"
export * from "./LockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports